"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SYNCED_PROMOTION_BANNER_MAX_LENGTH = void 0;
/** Max length for synced promotion banner copy (`ShopifyDiscount.bannerText` and admin UI). */
exports.SYNCED_PROMOTION_BANNER_MAX_LENGTH = 80;
